import { useApi } from "../hooks/useApi";

const api = useApi();

export async function getUserRegionViaOpenCage(lat: string, long: string) {
  try {
    const response = await api.get(`geolocation/region-from-gps-coord?lat=${lat}&long=${long}`);
    const region = response.data;
    return region;
  } catch (error) {
    throw error;
  }
}

export async function getAdressFromGpsCoords(lat: string, long: string) {
  try {
    const url = `${import.meta.env.VITE_APP_BASE_URL_OCD}q=${lat}%2c${long}&key=${import.meta.env.VITE_APP_KEY_API_OCD}`;

    const response = await fetch(url);

    // Si la réponse HTTP est une erreur (ex: 401, 403, 500)
    if (!response.ok) {
      throw new Error(`Erreur HTTP ${response.status} : ${response.statusText}`);
    }

    let result: any;
    try {
      result = await response.json();
    } catch (jsonError) {
      throw new Error("❌ Impossible de parser la réponse JSON d'OpenCage.");
    }

    const { results } = result;

    if (results?.length > 0 && results[0]?.components?.state) {

      return results[0].components.state;
    } else {
      throw new Error("❗ Aucune région trouvée dans la réponse d'OpenCage.");
    }
  } catch (error: unknown) {
    throw error;
  }
}